import { useEffect, useState } from "react";
import { COUNTRY_CHANGED_EVENT } from "services/requestCountry";

/**
 * Returns a nonce that increments whenever the visitor's country changes (a
 * manual pick in the country switcher fires COUNTRY_CHANGED_EVENT). Add the
 * returned value to a fetch effect's dependency array so game grids/sliders
 * refetch /games/by-category in place — the per-country sort scope and guest
 * currency then update without a page reload, matching the banner/promotions flow.
 *
 * A nonce (not a direct callback) is used so the component's own fetch effect
 * re-runs with fresh state, avoiding stale closures over page/sorting/providers.
 */
export default function useCountryRefetch() {
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    const onCountryChange = () => setNonce((n) => n + 1);
    window.addEventListener(COUNTRY_CHANGED_EVENT, onCountryChange);
    return () => window.removeEventListener(COUNTRY_CHANGED_EVENT, onCountryChange);
  }, []);

  return nonce;
}
